import { ButtonBase } from '@fukku/button/Base/ButtonBase'
import { BUTTON_INSPIRATIONAL_VARIANT } from '@fukku/button/Inspirational/constants'
import textActionM from '@fukku/styles/texts/textActionM.module.css'
import cx from 'classix'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import stylesBase from '../LineAnimatedBase.module.css'
import styles from './LineAnimatedButton.module.css'

interface LineAnimatedButtonProps extends React.ComponentProps<'button'> {
	readonly variant?: BUTTON_INSPIRATIONAL_VARIANT
	readonly active?: boolean
	readonly isTopBar?: boolean
}

export function LineAnimatedButton(
	props: LineAnimatedButtonProps
): React.ReactNode {
	const {
		children,
		disabled,
		active,
		variant = BUTTON_INSPIRATIONAL_VARIANT.DEFAULT,
		className,
		isTopBar = false,
		...rest
	} = props

	return (
		<ButtonBase
			{...rest}
			className={cx(
				className,
				stylesBase[variant],
				styles[variant],
				textActionM.className,
				applyStylesIf(active === true && !disabled, stylesBase.active),
				applyStylesIf(active === false && !disabled, stylesBase.unselected),
				applyStylesIf(isTopBar, stylesBase.topBar)
			)}
			disabled={disabled}
		>
			<span className={stylesBase.text}>{children}</span>
		</ButtonBase>
	)
}
